import React, { Component } from 'react';
import SkillBar from 'react-skills-bars';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import img from '../../assets/images/img2.png';
import sourcerer from '../../assets/images/sourcerer.svg';
import {
  Container, 
  Blurb, 
  Wrapper, 
  WrapSkills,
  Item, 
  CaptionWrapper,
  SourcererLink,
  Desc
} from './styles';

const skills = [
  {
    "type": "Java",
    "level": 50,
    "color": {
      "bar": "brown",
      "title": {
        "background": "brown"
      }
    }
  },
  {
    "type": "Spring",
    "level": 35,
    "color": {
      "bar": "green",
      "title": {
        "background": "green"
      }
    }
  },
  {
    "type": "React",
    "level": 20,
    "color": {
      "bar": "#2980b9",
      "title": {
        "background": "#2980b9 "
      }
    }
  },
  {
    "type": "Javascript",
    "level": 25,
    "color": {
      "bar": "yellow",
      "title": {
        "background": "yellow"
      }
    }
  },
  {
    "type": "Android",
    "level": 40,
    "color": {
      "bar": "green",
      "title": {
        "background": "green"
      }
    }
  },
  {
    "type": "Python",
    "level": 15,
    "color": {
      "bar": "#2980b9",
      "title": {
        "background": "#2980b9 "
      }
    }
  },
  {
    "type": "HTML",
    "level": 20,
    "color": {
      "bar": "red",
      "title": {
        "background": "red"
      }
    }
  },
  {
    "type": "CSS",
    "level": 10,
    "color": {
      "bar": "purple",
      "title": {
        "background": "purple"
      }
    }
  }
];

export default class About extends Component {
  render() {
    return ( 
      <>
        <Container>
          <Navbar />
          <Blurb>
            <Wrapper>  
              <Item>
                <img src={img} alt="" /> 
                <CaptionWrapper>
                  <h1>My Skills</h1>
                  <Desc>
                    <p>
                    <a>
                      A little bit of what I've used and studied.
                    </a>
                  </p>
                  </Desc>
                  <SourcererLink>
                    <p>
                      <a href="https://sourcerer.io/biachacon" target="_blank">
                        <img src={sourcerer} alt="Sourcerer"/> 
                      </a>
                      <a href="https://sourcerer.io/biachacon" target="_blank">
                        My visual profile from GitHub and git repositories.
                      </a>
                    </p>
                  </SourcererLink>
                </CaptionWrapper>               
              </Item>
              <WrapSkills>  
                <SkillBar skills={skills}/>
              </WrapSkills>
            </Wrapper>
          </Blurb>
        </Container>
        <Footer/>
      </>
    );
  }
}